import { useSelector } from "react-redux";
import { useState } from "react";
import styles from "../../../../styles/Components/new-insight/create-strategy/CreateStrategyForm.module.css";
import TextArea from "antd/lib/input/TextArea";
import { FaRegEdit } from "react-icons/fa";
import { FaCircleCheck } from "react-icons/fa6";
import { IoIosCloseCircle } from "react-icons/io";
import { useStrategy } from "../useCreateStrategyContext";

function StrategyDescription() {
  const {
    newInsightState: {
      createStrategyResult: { strategy_description: description },
    },
  } = useSelector((state) => state);

  const [isEditing, setIsEditing] = useState(false);

  const {
    setDescription,
    state: { strategyInfo, strategyDescription },
  } = useStrategy();

  return (
    <div className={styles.formItem}>
      <h5 className={styles.label}>Description:</h5>
      <div
        className={styles.formInput}
        style={!strategyDescription?.length ? { borderColor: "#ff4d4f" } : {}}
      >
        <TextArea
          className={`${styles.description}`}
          value={strategyDescription}
          readOnly={!isEditing}
          autoSize={{ minRows: 3, maxRows: 6 }}
          onChange={(e) => {
            setDescription(e.target.value);
            // setNewDescription(e.target.value);
          }}
          onBlur={() => setIsEditing(false)}
        />
        {!isEditing && (
          <span className={styles.edit} onClick={() => setIsEditing(true)}>
            <FaRegEdit size={16} />
          </span>
        )}
        {isEditing && (
          <>
            <span
              className={styles.submitEdit}
              style={{ marginRight: "8px" }}
              onClick={() => setIsEditing(false)}
            >
              <FaCircleCheck size={18} />
            </span>
            <span
              className={styles.closeEdit}
              onClick={() => {
                // setNewDescription(description);
                setDescription(description);
                setIsEditing(false);
              }}
            >
              <IoIosCloseCircle size={22} />
            </span>
          </>
        )}
      </div>
    </div>
  );
}

export default StrategyDescription;
